import React from 'react'
import healthCare from "./../../../assets/images/healthcare_pharma.png";
import education from "./../../../assets/images/education.png";
import homeCare from "./../../../assets/images/home_care.png";
import fitness from "./../../../assets/images/fitness.png";
import textile from "./../../../assets/images/textile.png";
import mobile from "./../../../assets/images/mobile_apps.png";
import ai from "./../../../assets/images/ai_ml.webp";
import petcare from "./../../../assets/images/pet_care.png";
import { NavLink, useNavigate } from "react-router-dom";

export default function IndustriesWorkedFor({ tag }) {

    const navigate = useNavigate();
    return (
        <>
            <div className="industries_worked" >
                <div className="container">
                    <div className='ind_title'>Industries We have worked for</div>
                    {/* <div className="d-flex justify-content-center">
                    
                    </div> */}
                    <div className="row">
                        <div className="col-md-12 ">
                            <div className="row">
                                
                                <div className="col-md-3"  style={{cursor: "pointer"}} onClick={()=>navigate("/services/ai-machine-learning-development")}>
                                    <div className="ind_box" style={{ backgroundImage: `url(${ai})`, width: "100%" }}>
                                        <div className="name">AI/ML</div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{cursor: "pointer"}}  onClick= {()=>navigate("/industries/healthcare")}>
                                    <div className="ind_box" style={{ backgroundImage: `url(${healthCare})` }}>
                                        <div className="name">Healthcare & Pharma</div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{cursor: "pointer"}} onClick={()=>navigate("/industries/petcare")}>
                                    <div className="ind_box" style={{ backgroundImage: `url(${petcare})` }}>
                                        <div className="name">Pet Care</div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{cursor: "pointer"}}  onClick= {()=>navigate("/industries/education")}>
                                    <div className="ind_box" style={{ backgroundImage: `url(${education})` }}>
                                        <div className="name">Education </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="d-flex justify-content-center">
                        <div className="ind_type">Other Industries</div>
                    </div> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="ind_box" style={{ backgroundImage: `url(${homeCare})` ,cursor: "pointer"}} onClick={()=>navigate("/industries/homecare")}>
                                        <div className="name">Home Care</div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ind_box" style={{ backgroundImage: `url(${fitness})` ,cursor: "pointer"}} onClick={()=>navigate("/industries/fitness")}>
                                        <div className="name">Fitness</div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ind_box" style={{ backgroundImage: `url(${textile})` ,cursor: "pointer"}} onClick={()=>navigate("/industries/textile-garments")}>
                                        <div className="name">Textile Garments</div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ind_box" style={{ backgroundImage: `url(${mobile})` ,cursor: "pointer"}} onClick={()=>navigate("/services/mobile-app-development")}>
                                        <div className="name">Mobile Apps</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
